<template>
  <div>
    <vue-draggable-resizable drag-handle=".headerClass" class="wrap container onePictureDialog" id='myCollectionContainer' :w="dragW" :h="dragH" v-if="visible">
      <!-- 展开收起图标 -->
      <img class="sideIconBox" :src='require("@/assets/images/sideIconLeft.png")' @click="sideShow()" />
      <div class="headerClass">
        <div class="headerTitle">
          <span>我的收藏</span>
        </div>
        <!-- 关闭按钮 -->
        <div class="boxClose">
          <img :src="require('@/assets/images/poscloseIcon.png')" style="cursor: pointer" @click="close()" />
        </div>
      </div>
      <div class="content">
        <!-- 标题和内容之间的分割线 -->
        <img class="splitLine" :src="require('@/assets/images/splitlineIcon.png')" />

        <a-card
          class="collect-card"
          :border="false"
          :tab-list="tabList"
          :active-tab-key="activedTabKey"
          @tabChange="(activedTabKey) => onTabChange(activedTabKey, 'key')">
          <span slot="customRender" slot-scope="item"> {{ item.name }} </span>

          <div class="content">
            <div v-if="showQueryBtn" class="contentTool">
              <a-input-search
                v-model="searchVal"
                placeholder="请输入检索关键词"
                @search="onSearch"/>
              <!-- 临时图斑 批量下载按钮 -->
              <a-button
                v-if="activedTabKey == '2' && showType == 'tree' && fileArr.length > 0"
                class="downloadBtn"
                type='primary'
                @click="downloadNodes">批量下载</a-button>
              <!-- 树和缩略图的切换图标 -->
              <div v-if="fileArr.length > 0 && (activedTabKey == '2' || activedTabKey == '3')" class="shiftBtns">
                <!-- 树列表 图标 -->
                <img
                  :src="showType == 'tree' ? require('@/assets/images/listCard_active.png') : require('@/assets/images/listCard.png')"
                  style="cursor: pointer"
                  @click="showTable()"/>
                <a-divider type="vertical" />
                <!-- 缩略图列表 图标 -->
                <img
                  :src="showType == 'image' ? require('@/assets/images/imageCard_active.png') : require('@/assets/images/imageCard.png')"
                  style="cursor: pointer"
                  @click="showImage()"/>
              </div>
            </div>

            <a-button
              class="addFileBtn"
              type="primary"
              icon="plus"
              v-if="showAddFolderBtn"
              @click="addOrEditDir(null, 'add')"
              style="display: flex; align-items: center; margin: auto">新增收藏文件夹
            </a-button>
            <!-- 树 -->
            <a-card v-if="showType == 'tree'" class="treeContent">
              <a-tree
                class="tree"
                :tree-data="fileArr"
                :replaceFields="replaceFields"
                :expanded-keys="expandedKeys"
                :draggable="true"
                :checkable="activedTabKey == '2' ? true : false"
                show-icon
                @check="check"
                @dblclick="dblClickItem"
                @drop="onDrop"
                @expand="onExpand"
              >
                <!-- 文件夹节点前面的图标 -->
                <img slot="group" :src="require('@/assets/images/folderIcon.png')" />
                <!-- 数据节点前面的图标 -->
                <img slot="file" :src="require('@/assets/images/fileIcon.png')" />
                <!-- 节点后面的操作图标 -->
                <template slot="custom" slot-scope="item">
                  <span style="margin-right: 20px">{{ item.dataName }}</span>
                  <div class="icons">
                    <img
                      v-if="item.wjtpye && activedTabKey !== '1'"
                      :src="require('@/assets/images/helpIcon.png')"
                      title="结果信息"
                      style="cursor: pointer; margin-right: 8px"
                      @click="showNodeDetail(item)"/>
                    <!-- 临时图斑 下载 -->
                    <img
                      v-if="activedTabKey == '2' && item.wjtpye"
                      :src="require('@/assets/images/downloadIcon.png')"
                      style="cursor: pointer; margin-right: 8px"
                      @click="downloadNode(item.bsm, item)"/>
                    <!-- 编辑文件 -->
                    <img
                      v-if="activedTabKey !== '1' && item.wjtpye"
                      :src="require('@/assets/images/editfileIcon.png')"
                      title="修改标注"
                      style="cursor: pointer; margin-right: 8px"
                      @click="editNode(item)"/>
                    <!-- 编辑文件夹 -->
                    <img
                      v-if="item.dirType"
                      :src="require('@/assets/images/editfileIcon.png')"
                      title="编辑文件夹"
                      style="cursor: pointer; margin-right: 8px"
                      @click="addOrEditDir(item, 'edit')"/>
                    <!-- 新增文件夹 -->
                    <img
                      v-if="item.dirType"
                      :src="require('@/assets/images/addIcon.png')"
                      style="cursor: pointer; margin-right: 8px"
                      @click="addOrEditDir(item, 'add')"/>
                    <!-- 删除节点 -->
                    <img
                      :src="require('@/assets/images/deleteIcon.png')"
                      style="cursor: pointer"
                      @click="deleteNode(item)"/>
                    <!-- 节点信息提示框 -->
                    <div v-if="item.showDetail" class="helpTooltip">
                      <div class="icons">
                        <div>
                          <a-icon type="environment" style="margin-right: 10px" />{{ fileInfo.dataFrom }}
                        </div>
                        <div>
                          <a-icon type="clock-circle" style="margin-right: 10px" />{{ fileInfo.updateTime }}
                        </div>
                        <div>
                          <a-icon type="user" style="margin-right: 10px" />{{ fileInfo.uname }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </a-tree>
            </a-card>
            <!-- 缩略图 -->
            <a-card v-if="showType == 'image'" class="listContent">
              <a-list :grid="{ gutter: 16, column: 2 }" :data-source="dataArr">
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-card class="listCard">
                    <div
                      class="imageBG imgWrap"
                      slot="cover"
                      :style="`background:url(${item.tempUrl}) no-repeat top/contain !important;`">
                      <a-dropdown placement="bottomLeft">
                        <img class="imageEdit" style="width: 32px; position:absolute; top:10px; left:10px; cursor: pointer" src="" />
                        <a-menu slot="overlay">
                          <a-menu-item @click="showDetails(item)">查看</a-menu-item>
                          <a-menu-item @click="editNode(item)">编辑</a-menu-item>
                          <a-menu-item @click="deleteNode(item)">删除</a-menu-item>
                        </a-menu>
                      </a-dropdown>
                    </div>
                    <!-- 缩略图的选择框 -->
                    <div
                      v-if="bigImgUrl"
                      @mousemove.stop
                      class="move"
                      ref="move"
                      :style="{ left: -left / 3 + 'px ', top: -top / 3 + 'px' }"></div>
                    <a-card-meta class="cardMeta">
                      <template slot="title">
                        <div class="metaTitle">
                          <span :title='item.dataName'>{{ item.dataName }}</span>
                          <a slot="extra">
                            <span>{{ item.createTime ? item.createTime.split(' ')[0] : '' }}</span>
                            <a-icon class="titleIcon" :type="item.descriptionIcon" @click="showDescription(item)"/>
                          </a>
                        </div>
                      </template>

                      <template v-if="item.showDetail" slot="description">
                        <div style="display: flex; justify-content: space-between">
                          <span>{{ item.dataFrom }}</span>
                          <span slot="extra" style="margin-right:23px">{{ item.uname }}</span>
                        </div>
                      </template>
                    </a-card-meta>
                  </a-card>
                </a-list-item>
              </a-list>
            </a-card>
          </div>
        </a-card>
      </div>

      <add-fileDialog ref="addFileDialog" @myCollectionHandleNode='myCollectionHandleNode'></add-fileDialog>
      <edit-collectionDialog ref="editCollectionDialog" @myCollectionHandleNode='myCollectionHandleNode'></edit-collectionDialog>
    </vue-draggable-resizable>
    <img v-show="sideVisible" class="sideshowClass" :src='require("@/assets/images/sideIconRight.png")' @click="sideShow()" />
  </div>
</template>

<script>
import AddFileDialog from './addFileDialog.vue'
import EditCollectionDialog from './editCollectionDialog.vue'
// import { getAction, postHeadersAction_ds, deleteAction } from '../../../../api/manage'
import { mapGetters } from 'vuex'
import dy3dMap from '../../../js/dy3dMap.js'
const DYMAP = new dy3dMap()
export default {
  name: 'MyCollection',
  components: { AddFileDialog, EditCollectionDialog },
  data() {
    return {
      showAddFolderBtn:false,
      showQueryBtn:false,
      bigImgUrl:'',
      tabList:[],
      dragW: 500,
      dragH: 593,
      sideVisible: false,
      visible: false, // 页面是否显示
      searchVal: '', // 搜索关键词
      activedTabKey: '1', // 选中tab的key值，对应数据字典里的数据
      // tabList: [], // tab数据
      fileArr: [], // 接口返回的处理过的树结构数据
      defaultData: [], // 处理过的数据的备份，用于清除搜索条件时展示全部数据;以及判断新增文件夹按钮是否显示
      fileArrCopy: [], // 接口返回的未处理过的树结构数据
      dataArr: [], // 树结构里的数据节点（不含文件夹）
      expandedKeys: [], // 展开的树节点
      dropObj: {}, // 把a拖拽到b的上面 下面或者里面，dropObj就是节点b的信息
      fileInfo: {}, //点击节点箭头显示的弹框信息
      fileNodes: [], //用于判断要删除的树节点下有没有文件
      parentNode: {}, // 文件拖拽后的父节点
      checkNodes: [], //复选框选中的节点
      tjxxData: [], // 汇总分析弹框里，
      treeClickCount: 0, // 树节点的点击次数，用于判断是不是双击
      graphicLayer: null, // 矢量数据图层
      promiseArr: [],
      replaceFields: {
        children: 'children',
        title: 'dataName',
        key: 'bsm',
      },
      url: {
        loadData: '/zcqc.wdsc/sys-sc-gis/getSysScGis',
        deleteFile: '/zcqc.wdsc/sys-sc-gis/delSysScGisDetails',
        deleteDir: '/zcqc.wdsc/sys-sc-gis/delSysScGisDir',
        dragFile: '/zcqc.wdsc/sys-sc-gis/sort',
        downLoadFile: '/zcqc.wdsc/sys-sc-gis/download',
      },
      description: false, //默认不展开详情
      descriptionIcon: 'down', //缩略图 图标上下
      showType: 'tree', //展示的是树还是缩略图
      sideClass: '', //样式
    }
  },
  mounted () {
    this.$bus.$on('refreshTreeData',(myCollectionTreeData) => {
      this.tabLists = myCollectionTreeData
      this.tabList = []
      this.dataArr = []
      myCollectionTreeData.map(item => {
        this.tabList.push({key:item.key, name:item.name, scopedSlots:{ tab: 'customRender' }})
      })
      this.fileArr = this.tabLists.filter(e => e.key == this.activedTabKey)[0].data
      this.addNodeSlots(this.fileArr)
      this.findDataNode(this.fileArr) 
      this.defaultData = JSON.parse(JSON.stringify(this.fileArr))
    });
  },
  watch: {
    activedTabKey(newValue, oldValue) {
      let targetArr = this.tabLists ? this.tabLists.filter(e => e.key == newValue) : []
      let treeData = targetArr.length > 0 ? targetArr[0].data : []
      // 筛选出一级有没有文件夹（有dirType字段是文件夹，有wjtype字段是文件）
      let dirNode = treeData.length > 0 ? treeData.filter((node) => node.dirType) : []
      // 搜索条件以及列表与图的切换按钮：树结构有节点时
      this.showQueryBtn = treeData.length > 0 ? true : false
      // 新建文件夹按钮出现：根目录没有文件夹节点时
      this.showAddFolderBtn = dirNode.length > 0 ? false : true
    }
  },
  beforeDestroy () {
    this.$bus.$off('refreshTreeData');
  },
  methods: {
    ...mapGetters(['userInfo']),
    // 展示页面
    showCard(map,data) {
      this.map = map
      this.visible = true
      this.sideVisible = false
      this.tabLists = data
      this.tabList = []
      data.map(item => {
        this.tabList.push({key:item.key, name:item.name, scopedSlots:{ tab: 'customRender' }})
      })
      this.activedTabKey = data.length > 0 ? data[0].key : ''
      this.fileArr = data.length > 0 ? data[0].data : []
      this.showType = 'tree'
      this.addNodeSlots(this.fileArr)
      this.findDataNode(this.fileArr) 
      this.defaultData = JSON.parse(JSON.stringify(this.fileArr))
    },
    // 显示 或 隐藏弹框
    sideShow() {
      this.visible = !this.visible
      this.sideVisible = !this.sideVisible
    },
    // 关闭弹框
    close() {
      // 清空地图上的数据
      let obj = {
        map:this.map,
        attr:'name',
        attrValue:'临时图斑'
      }
      DYMAP.removeLayerByAttr(obj)
      this.visible = false
      this.sideVisible = false
      this.activedTabKey = ''
    },
    // 遍历树节点，把数据节点过滤出来
    findDataNode(data){
      data.map(item => {
        if(item.wjtpye){
          item.descriptionIcon = 'down'
          this.dataArr.push(item)
        }
        item.children && item.children.length > 0 && this.findDataNode(item.children)
      })
    },
    // 树结构数据添加插槽
    addNodeSlots(data) {
      data.map((node) => {
        // 给每个节点添加插槽
        node.scopedSlots = { title: 'custom' }
        if (node.dirType) {
          // 节点是文件夹，把文件夹数据和文件数据合并成children，且要显示出来的节点名对应的字段名必须是一样的才能渲染
          node.slots = { icon: 'group' }
          // node.dataName = node.dirName
          // node.children = [...node.children, ...node.details]
        } else {
          // 节点是文件
          node.slots = { icon: 'file' }
          node.showDetail = false // 用于控制节点信息框的显示隐藏
        }
        if (node.children && node.children.length > 0) {
          this.addNodeSlots(node.children)
        }
      })
    },
    // 切换tab
    onTabChange(key, type) {
      console.log('切换',key,type);
      if(key != this.activedTabKey){
        // 清空地图上的数据
        let obj = {
          map:this.map,
          attr:'name',
          attrValue:'临时图斑'
        }
        DYMAP.removeLayerByAttr(obj)
      }
      this.activedTabKey = key
      this.searchVal = ''
      this.dataArr = []
      if(key == 1){
        this.showType = 'tree'
      }
      this.fileArr = this.tabLists.filter(e => e.key == key)[0].data
      this.addNodeSlots(this.fileArr)
      this.findDataNode(this.fileArr) 
      console.log('dataArr',this.dataArr);
      this.defaultData = JSON.parse(JSON.stringify(this.fileArr))
    },

    // 树结果搜索功能
    onSearch() {
      this.dataArr = []
      if (this.searchVal) {
        this.fileArr = []
        this.matchNodes(this.defaultData)
      } else {
        this.fileArr = this.defaultData
      }
      this.findDataNode(this.fileArr)
    },
    matchNodes(data){
      for(let i = 0; i < data.length; i++){
        if(data[i].dataName.indexOf(this.searchVal) > -1){
          this.fileArr.push(data[i])
        }else{
          if(data[i].children && data[i].children.length > 0){
            this.matchNodes(data[i].children)
          }
        }
      }
    },

    // 遍历树结构数据，根据id找到对应节点
    findNode(data, id, event) {
      data.map((node) => {
        if (node.bsm == id) {
          if (event == 'drag') {
            this.dropObj = node
          }
          if (event == 'switchIcon') {
            console.log('node', node)
            node.showDetail = !node.showDetail
            node.descriptionIcon = node.descriptionIcon === 'down' ? 'up' : 'down'
          }
        } else if (node.children && node.children.length > 0) {
          this.findNode(node.children, id, event)
        }
      })
    },

    // 拖拽功能
    onDrop(info) {
      console.log('拖拽', info)
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dragNode = info.dragNode.$vnode.data.props
      // dropPosition含义：
      // =0 表示拖拽到元素上
      // =1 表示拖拽到元素下面   那么放置元素的时候  应该放到这个位置+1的位置上
      // =-1 表示拖拽到元素上面   那么放置元素的时候 直接放到这个位置即可
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      // 找到dropKey对应的节点，判断节点类型，如果是文件，且dropPosition == 0，则给提示
      this.findNode(this.fileArr, dropKey, 'drag')
      if (this.dropObj.wjtpye && dropPosition == 0) {
        this.$message.warning('请拖拽到文件夹目录下！')
        return
      } else if (dragNode.dirType) {
        this.$message.warning('文件夹不支持拖拽！')
        return
      }
      // 递归查到元素所在树中的位置
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          // 示例里是item.key，需根据实际数据判断！！！
          if (item.bsm === key) {
            //在回调函数中将此元素，位置，以及元数组都返回
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.fileArr]

      // Find dragObject
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        // 查找到后删除此元素  这里相当于直接操作了data 所以我认为应该深拷贝
        arr.splice(index, 1)
        dragObj = item
      })
      if (!info.dropToGap) {
        // 拖拽到内容上
        loop(data, dropKey, (item) => {
          item.children = item.children || []
          // 示例添加到尾部，可以是随意位置
          item.children.push(dragObj)
        })
      }
      // 拖拽到元素之下的缝隙中，元素有子节点，并且当前元素子节点展开。此时元素放到了子节点的第一位。（当然可以根据具体情况随意位置）
      else if (
        (info.node.children || []).length > 0 && // Has children
        info.node.expanded && // Is expanded
        dropPosition === 1 // On the bottom gap
      ) {
        loop(data, dropKey, (item) => {
          item.children = item.children || []
          // 示例添加到尾部，可以是随意位置
          item.children.unshift(dragObj)
        })
      } else {
        let ar
        let i
        loop(data, dropKey, (item, index, arr) => {
          ar = arr
          i = index
        })
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj)
        } else {
          ar.splice(i + 1, 0, dragObj)
        }
      }
      this.fileArr = data
      console.log('dragNode', dragNode, this.fileArr)
      this.findParent(dragNode, this.fileArr)
      if (this.parentNode) {
        this.expandedKeys.push(this.parentNode.bsm)
      }
      this.$emit('myCollectionHandleNode', '拖拽', {dragNode: dragNode, parentNode:this.parentNode})
    },
    // 获取直接父节点
    findParent(node, arr, parentNode) {
      arr.map((item) => {
        console.log('item', item.dataName, item.bsm, parentNode)
        if (item.bsm == node.bsm) {
          this.parentNode = parentNode
        } else if (item.children && item.children.length > 0) {
          this.findParent(node, item.children, item)
        }
      })
    },

    // 新建或编辑文件夹
    addOrEditDir(node, type) {
      if (node == null) {
        // 说明点击的是上方新增文件夹按钮
        node = {}
        node.bsm = 0
        node.dirType = this.activedTabKey
        node.dirTypeName = this.tabList.filter((e) => e.key == this.activedTabKey)[0].name
        node.username = this.userInfo().realname
      }
      this.$refs.addFileDialog.openDialog(node, type, this.fileArrCopy)
    },
    // 展开选项
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    // 复选框勾选事件
    check(checkedKeys, e) {
      console.log('勾选', checkedKeys, e)
      this.checkNodes = []
      if (e.checkedNodes.length > 0) {
        e.checkedNodes.map((item) => {
          this.checkNodes.push(item.data.props)
        })
      }
    },
    // 加载图层
    loadLayer(url, id) {
      DYMAP.removeAllLayers(this.map)
      var myLayer = new mars3d.layer.ArcGisLayer({
        usePreCachedTilesIfAvailable: false, //必须false，否则报错
        url: 'http://192.168.1.12:6080/arcgis/rest/services/RDZCQC/MapServer',
        layers: '55',
        // layers: id.toString(),
        // url: url,
        flyTo: true,
        flyToOptions: {
          duration: 1,
        },
      })
      this.map.addLayer(myLayer)
    },
    // 展示图斑
    showPatternSpot(dataContent) {
      console.log('所有图层1', this.map.getLayers())
      // 矢量数据图层有的话先移除
      if (this.graphicLayer != null) {
        this.graphicLayer.remove()
        this.graphicLayer = null
      }
      // 创建矢量数据图层
      this.graphicLayer = new mars3d.layer.GraphicLayer({
        id: 'temporary-pattern-spot',
        name: '临时图斑',
      })
      this.map.addLayer(this.graphicLayer)
      var graphic = new mars3d.graphic.PolygonEntity({
        positions: dataContent.pointArry,
        style: dataContent.style,
      })
      // 数据添加到矢量图层里
      this.graphicLayer.addGraphic(graphic)
      graphic.flyTo({
        scale: 3, // 线面数据：scale控制边界的放大比例
        duration: 0.5,
      })
      console.log('所有图层2', this.map.getLayers())
    },
    // 编辑节点
    editNode(node) {
      console.log('编辑文件节点', node)
      this.$refs.editCollectionDialog.openDialog(node, this.activedTabKey)
    },
    // 下载节点
    downloadNode(bsm, node) {
      // console.log('下载节点', bsm, node, JSON.parse(node.dataContent))
      this.$emit('myCollectionHandleNode','下载',node)
      return
      var dataContent = JSON.parse(node.dataContent)
      this.downloadShp([dataContent.tcLayer], node.dataName)
    },
    // 批量下载节点
    downloadNodes() {
      if (this.checkNodes.length == 0) {
        this.$message.warning('请选择要下载的文件')
      } else {
        this.$emit('myCollectionHandleNode','批量下载',this.checkNodes)
        return
        // 把文件夹节点去掉
        var arr = []
        var features = []
        this.checkNodes.map((node) => {
          if (node.wjtpye) {
            arr.push(node)
          }
        })
        arr.map((item) => {
          features.push(JSON.parse(item.dataContent).tcLayer)
        })
        this.downloadShp(features, '临时图斑包')
      }
    },
    // 下载成shp压缩包的封装方法
    downloadShp(features, fileName) {
      var options = {
        folder: 'myshapes',
        types: {
          point: 'mypoints',
          polygon: 'mypolygons',
          line: 'mylines',
        },
        fileName: fileName,
      }

      // var zip = require('../../../../../../node_modules/shp-write/src/zip')
      // var content = zip(
      //   {
      //     type: 'FeatureCollection',
      //     features: features,
      //   },
      //   options
      // )
      // 定义需要下载的 ZIP 文件名称
      const a = document.createElement('a')
      a.href = `data:application/zip;base64`
      // a.href = `data:application/zip;base64,${content}`
      a.download = options.fileName + '.zip'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    // 删除节点
    deleteNode(node) {
      console.log('删除', node)
      this.fileNodes = []
      var type = node.wjtpye ? 'file' : 'dir' //判断要删除的是文件还是文件夹
      if (node.wjtpye || node.children.length == 0) {
        // 删除的是文件或者空文件夹
        var that = this
        this.$confirm({
          content: '确认删除?',
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            that.$emit('myCollectionHandleNode','删除',node)
          },
          onCancel() {},
        })
      } else {
        // 删除的是有下级的文件夹
        this.hasFile(node.children)
        if (this.fileNodes.length > 0) {
          this.$message.warning('该文件夹下有数据，请先把数据拖拽到其他目录')
        } else {
          var that = this
          this.$confirm({
            content: '确认删除?',
            okText: '删除',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
              that.$emit('myCollectionHandleNode','删除',node)
            },
            onCancel() {},
          })
        }
      }
    },
    // 判断要删除的文件夹下有没有文件
    hasFile(data) {
      data.map((item) => {
        if (item.wjtpye) {
          this.fileNodes.push(item)
        } else if (item.children && item.children.length > 0) {
          this.hasFile(item.children)
        }
      })
    },
    // 点击文件节点后的三角图标查看信息
    showNodeDetail(node) {
      this.closeHelpTooptip(this.fileArr, node.eventKey)
      this.fileInfo.dataFrom = node.dataFrom
      this.fileInfo.updateTime = node.updateTime ? node.updateTime : node.createTime
      this.fileInfo.uname = node.uname
    },
    // 遍历树结构数据，关闭其他节点的帮助提示框
    closeHelpTooptip(data,bsm){
      data.map(item => {
        if(item.bsm != bsm){
          item.showDetail = false
        }else{
          item.showDetail = !item.showDetail
        }
        item.children && item.children.length > 0 && this.closeHelpTooptip(item.children,bsm)
      })
    },
    // 新增 编辑节点回来的回调
    myCollectionHandleNode(action,msg){
      this.$emit('myCollectionHandleNode',action,msg)
    },
    // 节点双击事件
    dblClickItem(v, e) {
      var node = e.$vnode.data.props
      this.showDetails(node)
    },
    //查看
    showDetails(item) {
      var dataContent = JSON.parse(item.dataContent)
      console.log('点击查看',item,dataContent)
      if (this.activedTabKey == 3) {
        var fwData = item.dataFrom == '核算任务' ? dataContent : JSON.parse(dataContent.fwData)
        var tjxxData = dataContent.tjxxData ? dataContent.tjxxData : ''
        // var key = ''
        // switch (item.dataFrom) {
        //   case '叠加分析':
        //     key = 'djfx'
        //     break
        //   case '缓冲分析':
        //     key = 'hcfx'
        //     break
        //   case '核算任务':
        //     key = 'gs'
        //     break
        //   default:
        //     key = dataContent.projectBsm
        //     break
        // }
        this.$emit('dblclickData', {
          key: dataContent.pageKey,
          fwData: fwData,
          tjxxData: tjxxData,
          layerId: dataContent.layerBsm,
          methodsQuery: dataContent.methodsQuery,
          attrValue: dataContent.attrValue,
          pageKey: dataContent.pageKey
        })
      } else if (this.activedTabKey == 2) {
        // 临时图斑双击
        // console.log('双击临时图斑',node,dataContent);
        // this.loadLayer()
        this.showPatternSpot(dataContent)
      }
    },
    //图片形式展示的icon展开详细信息
    showDescription(item) {
      console.log('详情展开', item)
      this.findNode(this.fileArr, item.bsm, 'switchIcon')
      this.$forceUpdate()
    },
    //展示树形列表页
    showTable() {
      this.showType = 'tree'
    },
    showImage() {
      this.showType = 'image'
    },
    // 关闭页面
    handleClose() {
      this.visible = false
      if (this.graphicLayer != null) {
        this.graphicLayer.remove()
        this.graphicLayer = null
      }
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  z-index: 1000 !important;
  backdrop-filter: blur(8px);
  user-select: none;
  .headerClass{
    position: relative;
    height: 30px;
    cursor: move;
    padding: 10px 8px 0;
    .headerTitle {
      position: absolute;
      top: -5px;
      left: 8px;
    }
    .boxClose {
      position: absolute;
      top: 4px;
      right: 0;
    }
  }
  & > .content {
    padding: 0 8px;
    width: 100%;
    height: calc(100% - 30px);
    display: flex;
    flex-direction: column;
    .splitLine {
      width: 100%;
      height: 2px;
      margin-top: 10px;
    }

    .collect-card {
      width: 100%;
      height: calc(100% - 20px);
      display: flex;
      flex-direction: column;
      border: 0;
      background: transparent !important;
      .content {
        height: 100%;
        background: rgba(255, 255, 255, 0.1) !important;
        border-radius: 4px;
        padding: 10px 6px;
        .contentTool {
          display: flex;
          align-items: center;
          height: 32px;
          .downloadBtn {
            background: rgba(255, 255, 255, 0.50); 
            border-radius: 4px; 
            border-color: transparent;
            margin-left: 4px;
          }
          .shiftBtns {
            display: flex; 
            align-items:center; 
            justify-content:flex-end; 
            border:1px solid rgba(255, 255, 255, 0.50); 
            padding:4px; 
            border-radius:4px;
            position:absolute;
            right: 6px;
          }
        }
        .treeContent {
          height: calc(100% - 32px);
          overflow: auto;
          padding-top: 8px;
          border: 0;
          background: transparent !important;
          .helpTooltip {
            position: relative;
            .icons {
              position: absolute;
              right: 23px;
              top: 1px;
              background-color: rgba(255, 255, 255, 0.30);
              backdrop-filter: blur(10px);
              border-radius: 5px;
              padding: 10px 15px;
              z-index: 1;
              div:not(:last-child) {
                margin-bottom: 10px;
              }
            }
          }
          /deep/.ant-card-body {
            overflow: auto;
            height: 100%;
            padding: 0 !important;
          }
        }
        .listContent {
          height: calc(100% - 30px);
          overflow: auto;
          margin-top: 8px;
          background: transparent !important;
          border: 0;
          .listCard {
            background: transparent !important;
            border: 1px solid rgba(225,225,225,0.3);
            color: #fff;
            position: relative;
            .imageBG {
              height: 168px;
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
              overflow: hidden;
            }
            .cardMeta {
              margin: auto;
              padding: 5px 4px;
              position: absolute;
              bottom: 0%;
              width: 100%;
              a {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.5) !important;
              }
              .metaTitle {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 4px;
                & > span {
                  display: inline-block;
                  width: 47%;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  cursor: default;
                }
                .titleIcon {
                  margin-left: 9px;
                  margin-right: 4px;
                  color: rgb(255, 255, 255);
                  font-size: 10px;
                }
              }

              /deep/.ant-card-meta-title {
                font-size: 16px;
                color: #fff !important;
              }
              /deep/.ant-card-meta-description {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.5) !important;
              }
              /deep/.ant-card-meta-detail > div:not(:last-child) {
                margin-bottom: 0px !important;
              }
            }
            .dropdownTool {
              position: absolute;
              top: 61%;
              right: 0%;
            }
            .move {
              position: absolute;
              left: 0;
              top: 0;
              width: 60px;
              height: 60px;
              background: pink;
              cursor: move;
            }
          }
          /deep/.ant-card-body {
            padding: 0px !important;
            height: 100%;
          }
        }
        /deep/ .ant-tabs-bar {
          margin: 0;
        }
        /deep/ .ant-input-affix-wrapper {
          width: 45%;
          .ant-input {
            border: 1px solid rgba(255, 255, 255, 0.3);
            &::placeholder {
              color: rgba(255, 255, 255, 0.3);
              font-size: 12px;
            }
          }
        }
        /deep/ .anticon.anticon-caret-down.ant-tree-switcher-icon {
          color: rgba(255, 255, 255, 0.5);
        }
      }
      .icons {
        position: absolute;
        right: 10px;
        top: 7px;
      }
      /deep/ .ant-card-head-wrapper {
        background: transparent !important;
      }
      /deep/ .ant-tabs .ant-tabs-large-bar .ant-tabs-tab {
        padding: 0px 6px 6px 0;
        color: rgba(255, 255, 255, 0.5);
        font-size: 14px;
        span {
          border-right: 1px solid rgba(255, 255, 255, 0.2);
          padding: 1px 6px 1px 0;
        }
      }
      /deep/ .ant-card-head {
        padding: 0;
        width: 100%;
        min-height: 36px;
        height: 36px;
        border-bottom: 0;
      }
      /deep/ .ant-card-body {
        width: 100%;
        height: calc(100% - 36px);
        padding: 0 !important;
      }
      /deep/ .ant-tabs,
      /deep/ .ant-tabs-bar,
      /deep/ .ant-tabs-nav-container,
      /deep/ .ant-tabs-nav-wrap,
      /deep/ .ant-tabs-nav-scroll,
      /deep/ .ant-tabs-nav,
      /deep/ .ant-tabs-nav > div,
      /deep/ .ant-tabs-tab {
        height: 100%;
      }
      /deep/ .ant-tabs-tab {
        display: flex;
        align-items: center;
      }
      /deep/ .ant-tabs-nav.ant-tabs-nav-animated {
        & > div {
          display: flex;
          justify-content: space-around;
        }
      }
      /deep/ .ant-tabs-bar {
        border-bottom: 0;
        height: 100%;
        display: flex;
        align-items: center;
      }
      /deep/ .ant-tabs-tab-active {
        div {
          color: #1890ff;
        }
      }
      /deep/ .ant-tabs-tab {
        padding-bottom: 5px;
        margin: 0px;
        position: relative;
      }
      /deep/ .ant-tabs .ant-tabs-tab.ant-tabs-tab span {
        color: rgba(255, 255, 255, 0.50) !important;
      }
      /deep/ .ant-tabs .ant-tabs-tab.ant-tabs-tab-active span {
        color: #fff !important;
      }
      /deep/ .ant-tree-title {
        font-size: 14px;
      }
      /deep/ .ant-tabs-ink-bar {
        display: none !important;
      }
      /deep/ .ant-tree-child-tree > li:first-child {
        padding-top: 4px;
      }
      /deep/ .ant-tree-child-tree > li {
        background: transparent !important;
      }
      /deep/ .ant-tree-iconEle.ant-tree-icon__customize {
        line-height: 16px;
      }
      /deep/ .ant-tree-checkbox-inner,
      /deep/ .ant-tree-checkbox:hover .ant-tree-checkbox-inner,
      /deep/ .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
        background-color: transparent;
        border: 1px solid rgba(255, 255, 255, 0.5);
      }
      /deep/ .ant-tree li .ant-tree-node-content-wrapper:hover,
      /deep/ .ant-tree-treenode-checkbox-checked,
      /deep/ .ant-tree-treenode-selected .ant-tree-node-selected {
        background: rgba(255, 255, 255, 0.2);
      }
      /deep/ .ant-tree-treenode-selected {
        background: transparent;
      }
    }
  }

  /deep/ .ant-divider-horizontal {
    width: 100%;
    min-width: 93%;
    margin: 4px 0 10px;
    background: #4d626f;
  }

  /deep/ .ant-tree-checkbox {
    top: 0em;
  }
  // 隐藏拖拽弹框的小圆圈，并调整位置
  /deep/ .handle {
    opacity: 0;
  }
  /deep/ .handle-tl {
    top: -5px;
    left: -5px;
  }
  /deep/ .handle-tr {
    top: -5px;
    right: -5px;
  }
  /deep/ .handle-bl {
    bottom: -5px;
    left: -5px;
  }
  /deep/ .handle-br {
    bottom: -5px;
    right: -5px;
  }

  /deep/ .ant-tree-iconEle.ant-tree-icon__customize {
    line-height: 21px;
    margin-right: 3px;
  }
  /deep/ .ant-tree-node-content-wrapper {
    padding: 0;
  }
}
.bigPic {
  width: 360px;
  height: 360px;
  margin: 0 0 20px;
  border: 1px solid #eee;
  position: absolute;
  top: 0;
  right: 0;
  border: 2px solid #f90;
  background-position: 0 0;
  background-size: 212% 200%;
  background-repeat: no-repeat;
  z-index: 2;
}

/deep/.ant-card-bordered {
  border: 0px solid #e8e8e8;
}
/deep/ .ant-dropdown-menu-item {
  color: #fff;
  font-size:14px;
  padding: 2px 10px;
}
// 解决树结构 节点内容太长 的问题
/deep/ ul li {
  position: relative;
  & > span:last-child {
    display: inline-block;
    width: calc(100% - 48px);
    .ant-tree-title {
      display: inline-block;
      width: calc(100% - 30px);
      span {
        width: calc(100% - 80px);
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}
</style>